/* src/app/features/habilitacao/habilitacao-alternativa/pesquisa-habilitacao-alternativa/listagem/habilitacao-alternativa-listagem.component.scss */
th {
  font-weight: 400;
}
.letra-miuda {
  font-size: 14px;
  font-style: italic;
  text-align: bottom;
}
.botoes {
  display: flex;
  justify-content: right;
  align-items: center;
}
#pointer :hover {
  cursor: pointer;
}
#nowrap {
  white-space: nowrap;
}
.hover-hint:hover {
  font-weight: 900;
}
@media screen and (min-width: 1025px) {
  .fonte {
    font-size: 16px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .fonte {
    font-size: 12px;
  }
}
@media screen and (min-width: 481px) and (max-width: 768px) {
  .fonte {
    font-size: 11.5px;
  }
}
@media screen and (min-width: 320px) and (max-width: 480px) {
  .mobile {
    display: none;
  }
  .fonte {
    font-size: 10px;
  }
  .botaoMenor {
    width: 90%;
    height: 90%;
    font-size: 2vw;
  }
  .quebra_coluna {
    word-break: break-all;
  }
}
/*# sourceMappingURL=habilitacao-alternativa-listagem.component.css.map */
